<!--
 * @Author: chengchangjun
 * @Description: 宣传月度统计
-->
<template>
  <el-card :body-style="{ height: '100%', overflow: 'auto' }" class=" h-full">
    <div class="mb-20px">
      <el-date-picker
        size="small mr-10px"
        v-model="monthTime"
        type="month"
        :placeholder="`${$t('请选择日期')}`"
        value-format="yyyy-MM"
        clearable
      >
      </el-date-picker>
      <el-button size="small" type="primary" @click="getTableData">
        {{ $t('搜索') }}
      </el-button>
      <el-button size="small" type="primary" @click="reset">
        {{ $t('重置') }}
      </el-button>
      <el-button size="small" @click="exportFile()">
        {{ $t('导出') }}
      </el-button>
    </div>
    <div class="h-[calc(100%-105px)]">
      <el-table :data="tableData" v-loading="tableLoading" ref="table" border height="100%">
        <el-table-column type="index" :label="$t('序号')" width="50" />
        <el-table-column
          :prop="item.prop"
          :label="`${$t(item.label)}`"
          v-for="(item, index) in tableColumns"
          :key="index"
        >
          <template slot-scope="scope">
            <div
              v-if="
                item.prop === 'internalAvg' ||
                  item.prop === 'provinceAvg' ||
                  item.prop === 'groupAvg' ||
                  item.prop === 'taskAvg' ||
                  item.prop === 'monthAvg'
              "
            >
              {{ scope.row[item.prop] }}%
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('操作')" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="operateBtn(scope.row, 'read')">
              {{ $t('查看') }}
            </el-button>
            <el-button size="mini" @click="operateBtn(scope.row, 'update')">
              {{ $t('编辑') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="mt-20px text-right"
      background
      @current-change="getTableData"
      @size-change="getTableData"
      :current-page.sync="page.pageNo"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :page-size.sync="page.pageSize"
      :total="page.total"
      :pager-count="5"
    ></el-pagination>
  </el-card>
</template>

<script>
// tool
import { downLoadExcel } from '@/assets/js/CommonDownload'
import { map, get, isNil, isEmpty } from 'lodash'
import dayjs from 'dayjs'
// api
import { RoyaltiesTargetStatisticsApi } from '@wiz-api/workbench'

const royaltiesTargetStatisticsApi = new RoyaltiesTargetStatisticsApi()

export default {
  data() {
    return {
      monthTime: '',
      tableColumns: [
        {
          prop: 'time',
          label: '月度',
        },
        {
          prop: 'internalAvg',
          label: '平均内网完成率%',
        },
        {
          prop: 'provinceAvg',
          label: '平均公司完成率%',
        },
        {
          prop: 'groupAvg',
          label: '平均集团完成率%',
        },
        {
          prop: 'taskAvg',
          label: '平均任务稿件完成率%',
        },
        {
          prop: 'monthAvg',
          label: '平均月度综合完成率%',
        },
      ],
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableLoading: true,
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  methods: {
    async getTableData() {
      this.tableLoading = true
      const [err, res] = await royaltiesTargetStatisticsApi.page({
        body: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          time: this.monthTime ? dayjs(this.monthTime).format('YYYY-MM-01 HH:mm:ss') : null,
        },
      })
      if (!err) {
        this.tableData = map(res.items, (item) => {
          return {
            ...item,
            time: dayjs(item.time).format('YYYY-MM'),
          }
        })
        this.page.total = res.totalCount
        this.tableLoading = false
      }
    },
    async reset() {
      this.monthTime = ''
      await this.getTableData()
    },
    async exportFile() {
      const [err, res] = await royaltiesTargetStatisticsApi.callExport({
        body: {
          pageNo: 1,
          pageSize: 9999,
          time:
            isNil(this.monthTime) || isEmpty(this.monthTime)
              ? null
              : dayjs(this.monthTime).format('YYYY-MM-01 HH:mm:ss'),
        },
        returnType: 'Blob',
      })
      if (!err) {
        downLoadExcel('宣传月度统计导出', res)
      }
    },
    operateBtn(row, type) {
      this.$router.push({
        path: `${this.routerBase}/portal-management/royalties-management/propaganda-monthly-statistics-detail`,
        query: {
          type,
          time: get(row, 'time') || '',
        },
      })
    },
  },
  created() {
    this.getTableData()
  },
}
</script>
